/**
 * Realtime notification backend: Pusher (legacy) or Anycable.
 * Derived from practice preference realtime_notification_backend.
 */
export type RealtimeBackend = 'pusher' | 'anycable';

export const REALTIME_BACKEND_PUSHER: RealtimeBackend = 'pusher';
export const REALTIME_BACKEND_ANYCABLE: RealtimeBackend = 'anycable';
